<template>
  <div class="inputBoxWrap">
      <suggestions v-model="value" :options="options" :onInputChange="onInputChange" :onItemSelected="onSearchItemSelected" >
        <div slot="item" slot-scope="props" class="single-item">
          <span class="name">{{props.item.value}}</span>
        </div>
      </suggestions>
      <label>{{item.label}}</label>
      <p class="errorMsg" v-if="statusVuex[refs].ShowError">{{errorMsg}}</p>
  </div>
</template>

<script>
  import 'v-suggestions/dist/v-suggestions.css';
  import DataForInput from '@/store/Form/longFormOptions';
  import {mapState} from 'vuex';

  export default {
    name: "vmSelectDadata",
    props:{
      refs: {
        type: String,
        default: 'null'
      },
    },
    data() {
      return {
        query:'',
        selectedCountry: null,
        selectedSearchItem: null,
        options: {
          placeholder: DataForInput[this.refs].placeholder,
        },
        item: DataForInput[this.refs],
      }
    },
    computed:{
      ...mapState({
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
      }),
      value:{
        get(){
          return this.valueVuex[this.refs]
        },
        set(value){
          let utiputi = {
            target:this.refs,
            value: value
          };
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      errorMsg(){
        return this.statusVuex[this.refs].msg;
      },
    },
    components: {
      suggestions:()=>import('v-suggestions')
    },
    methods:{
      onInputChange (query) {
        if (query.trim().length === 0) {
          return null
        }
        if (this.refs === 'WORK_TITLE') {
          return new Promise(resolve => {
            this.$myApi.suggestResultGigData(query, 5)
                .then(resp => {
                  let suggestions = resp.data.suggestions;
                  let result = (Array.isArray(suggestions) && suggestions.length) ? suggestions : [];
                  resolve(this.suggestions = result);
                })
                .catch(err => {
                  console.error("Ошибка при запросе suggestResultGigData", err);
                });
          });
        } else {
          return new Promise(resolve => {
            this.$myApi.suggestResult(this.refs, {value: query}).then(resp => {
              let dadataSuggest = resp.data.result.suggestions;
              let result = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
              resolve(result);
            });
          });
        }
      },
      onSearchItemSelected (item) {
        this.$palantir.trackInputBlur(this.refs, item.value);
        this.selectedSearchItem = item;
        this.query = item.value;
        this.$store.dispatch('saveSendData',{
          target: this.refs,
          value: item.value,
          jsonSuggestion:item
        });
        this.$store.dispatch('saveSendData',{
          target: this.refs + '_DADATA',
          value: item,
        });
      },

    },

  }
</script>

<style scoped>
.errorMsg { color: red; font-size: .4rem; }
.inputBoxWrap { position: relative; }
.inputBoxWrap label {
	position: absolute;
	background-color: #fff0;
	padding: .1rem  .4rem;
	top: 0;
	font-size: .4rem;
	border-top-left-radius: 0.4rem;
	color: #869A95;
	padding-left: .6rem;
}
input:focus ~ label {
	transition: .3s ease-out;
	height: 0;
	opacity: 0;
}
.inputBoxWrap{font-size: 0.5rem}
@media (min-width: 768px) {
	.errorMsg { font-size: .8rem; }
  .inputBoxWrap{font-size: 1rem}
	.inputBoxWrap label { font-size: 1rem; padding-left: 1.6rem; }
}
</style>
